<template>
  <b-button
    :variant="variant || 'link'"
    @click="click"
    :disabled="loading"
    v-b-tooltip.hover
    :data-id="id"
    :title="title"
    :class="btnClass"
  >
    <i v-if="loading" class="far fa-spinner-third fa-spin"></i>
    <i v-else-if="classes" class="far" :class="classes"></i>
    {{ text || '' }}
  </b-button>
</template>
<script>
export default {
  name: 'ActionButton',
  props: ['title', 'text', 'classes', 'callback', 'variant', 'btnClass'],
  data() {
    return {
      id: (this.text || this.title || '').toString().replace(/ /gi, '_'),
      loading: false
    };
  },
  methods: {
    async click() {
      try {
        this.loading = true;
        await this.callback();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
